import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import Modal from 'react-modal';
import './modal.css';
import firebase from 'firebase';
import Alert from 'react-s-alert';


const database=firebase.database();



const customStyles = {
	content : {
	  top                   : '50%',
	  left                  : '50%',
	  right                 : 'auto',
	  bottom                : 'auto',
	  transform             : 'translate(-50%, -50%)',
	  width                 : '450px',
	  height: '550px',	 
	  
	}
  };


class Modal_Empresa extends Component{

	constructor(props){

		super(props);

		this.state={
			empresas:[],
			isActive:false,
			uid:'',
			codigo_empresa:'',
			codigo_activacion:'',
			correo:'',
			estado:'',
			razon_social:'',
			representante:'',
			telefono_empresa:'',
			nodo:props.nodo
		}

		

		this.empresaRef = database.ref().child('Empresa');
		
		this.handleSubmit=this.handleSubmit.bind(this);

	}

	componentWillMount(){

		Modal.setAppElement('body');
	}

	componentDidMount(){
		
		this.empresaRef.on('value', this.gotData, this.errData);
	}
	
	gotData=(data) =>{
		
		
		const dataempresa=data.val();
		
		const keys = Object.keys(dataempresa);
		
		for (let i = 0; i < keys.length; i++) {
			const k = keys[i];
	
			if(k===this.state.nodo){
				
				
				this.setState({
					
					
					codigo_empresa:dataempresa[k].codigo_empresa,
					codigo_activacion:dataempresa[k].codigo_activacion,
					correo:dataempresa[k].correo,
					estado:dataempresa[k].estado,
					razon_social:dataempresa[k].razon_social,
					representante:dataempresa[k].representante,
					telefono_empresa:dataempresa[k].telefono_empresa
			
				})
				
				
			}

	
		 }
		
		
		
		
	}
	errData= (err)=>{
		
		console.log(err);
		
	}
	
	
	

	toggleModal=()=>{

		this.setState({

			isActive:!this.state.isActive
		})

	}

	handleSubmit(event){

		if(this.contrasena.value===this.confirm.value){
			
				let codigo_empresa=this.codigoEmpresa.value;
				let razon_social=this.razon_social.value;
				let telefono=this.telefono.value;
				let correo=this.correo.value;
				let contrasena=this.contrasena.value;
				let representante=this.representante.value;
				
				
				
				this.empresaRef.child(this.state.nodo).update({
					
					codigo_empresa:codigo_empresa,
					razon_social:razon_social,
					telefono_empresa:telefono,
					representante:representante,
					correo:correo
					
					
				})
				


				
				var user = firebase.auth().currentUser;

				user.updateEmail(correo).then(function() {
				  // Update successful.
				}).catch(function(error) {
				  // An error happened.
				});
				
				user.updatePassword(contrasena).then(function() {
				  // Update successful.
				}).catch(function(error) {
				  // An error happened.
				});

				Alert.success('Datos actualizados correctamente', {
					effect: 'genie',
					position: 'bottom-right',
					timeout:2000			
				});
				this.toggleModal();
			
		}else{
			
				Alert.warning('Las contraseñas ingresadas no coinciden', {
					effect: 'genie',
					position: 'bottom-right',
					timeout:2000			
				});
			
			
		}
		

		
		event.preventDefault();
		

	}


	//<button className="btn btn-seconds buttons" onClick={this.toggleModal}>Informacion de la empresa</button>

	render(){

		return(

			<div >

					<li><Link to="#" onClick={this.toggleModal}>Informacion empresa</Link></li>
					<Modal isOpen={this.state.isActive} onRequestClose={this.toggleModal}  style={customStyles} >

						<form method="POST" action="" onSubmit={this.handleSubmit}>

							<h3>Editar informacion de la empresa</h3>
							<hr/>
								<div className="form-group">
									<label htmlFor="empresa" >Nombre de la empresa:</label>
									<input 	type="text" className="form-control" name="empresa"
										ref={input => {this.codigoEmpresa=input;}}
										defaultValue={this.state.codigo_empresa}
										placeholder="Nombre de la empresa"
										autoComplete="off" required
								 />
								</div>

								<div className="form-group">
									<label htmlFor="razon_social" >Razon Social:</label>
									<input type="text" className="form-control" name="razon_social"
										ref={input => {this.razon_social=input;}}
										defaultValue={this.state.razon_social}
										placeholder="Razon Social"
										autoComplete="off" required
									/>
								</div>



								<div className="form-group">
									<label htmlFor="telefono" >Telefono:</label>
									<input type="text" className="form-control" name="telefono"
										ref={input => {this.telefono=input;}}
										defaultValue={this.state.telefono_empresa}
										placeholder="Telefono"
										autComplete="off" required
									 />
								</div>

								<div className="form-group">
									<label  htmlFor="correo" >Correo:</label>
									<input type="text" className="form-control" name="correo"
										ref={input => {this.correo=input;}}
										defaultValue={this.state.correo}
										placeholder="correo"
										autoComplete="off" required
									 />
								</div>
								<div className="form-group">
									<label htmlFor="contrasena">Contraseña</label>
									<input type="password" className="form-control" name="contrasena"
									ref={input => {this.contrasena=input}}
									defaultValue=""
									autoComplete="off" required placeholder="Contraseña"
									/>
								</div>
								<div className="form-group">
									<label htmlFor="confirm-contrasena">Confirmar contraseña</label>
									<input type="password" className="form-control" name="confirm-contrasena"
									ref={input=>{this.confirm=input}}
									defaultValue=""
									autoComplete="off" required placeholder="Confirmar contraseña"									
									/>
								</div>


								<div className="form-group">
									<label  htmlFor="representante" >Representante:</label>
									<input type="text" className="form-control" name="representante"
										ref={input => {this.representante=input;}}
										defaultValue={this.state.representante}
										placeholder="Representante"
										autocomplete="off" required
									 />
								</div>



							<hr/>

							<button className="btn btn-primary buttons" type="submit" >Guardar</button>							
						</form>
						   <button className="btn btn-default buttons btnmargin" onClick={this.toggleModal}>Cerrar</button>
					</Modal>



			</div>
		);
	}
}

export default Modal_Empresa;



// WEBPACK FOOTER //
// ./src/Components/Emp_Empresas/empresa_modal.jsx